<template>
  <div>
    <b-modal ref="printDocumentModal" :title="modalTitle" :no-close-on-backdrop="true">
      <b-row>
        <b-col cols="3">
          <label>{{$t('modal_dialogs.print_document.columns')}}</label>
        </b-col>
        <b-col>
          <multiselect v-model="printData.columns" :max-height="200"
                       placeholder="Choose columns for printing" label="header" track-by="field"
                       :options="columns" :multiple="true"
                       :taggable="true" :close-on-select="false"></multiselect>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <b-btn size="sm" variant="secondary" @click="clearFields">
          {{$t('buttons.common.clear')}}
        </b-btn>
        <b-btn size="sm" variant="success" v-if="settings.isHtmlReport" @click="print">
          {{$t('buttons.common.print')}}
        </b-btn>
        <b-btn size="sm" variant="success" v-if="settings.isFileReport" @click="downloadFile">
          {{$t('buttons.common.download_report')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {
    cleanFilters,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { saveAs } from 'file-saver';

  export default {
    components: {
      Multiselect
    },
    data() {
      return {
        settings: {
          url: '',
          allowChanges: false,
          isHtmlReport: false,
          isFileReport: false
        },
        columns: [],
        printData: {
          columns: []
        }
      }
    },
    methods: {
      async openModal() {
        const response = await this.$http.get(`${this.settings.url}`).then(handlerResponse);
        if (this.settings.allowChanges) {
          this.printData.columns = response.default_columns;
          this.columns = response.columns;
          this.$refs['printDocumentModal'].show();
        } else {
          this.printData.columns = response
          if (this.settings.isHtmlReport) this.print();
          else this.downloadFile();
        }
      },
      print() {
        let printData = {columns: {}};
        this.printData.columns.forEach((e) => {
          printData.columns[e.header] = e.field;
        });
        this.$http.post(`${this.settings.url}`, printData).then((response) => {
          const newTab = window.open();
          (async () => {
            await newTab.document.write(response.body);
            newTab.print()
          })()
        }).catch((error) => {
          console.log(error);
          this.$notify(setNotifyData('', 'Error has occurred', 'error'));
        });
      },
      downloadFile() {
        let printData = {columns: {}};
        this.printData.columns.forEach((e) => {
          printData.columns[e.header] = e.field;
        });
        this.$http.post(`${this.settings.url}`, printData).then((response) => {
          const content = response.body.content;
          const uri = `data:${response.body['file_type']};base64,${content}`;
          fetch(uri)
            .then((file) => {
              file.blob()
                .then((blob) => {
                  saveAs(blob, response.body['file_name']);
                });
            });
        }).catch((error) => {
          console.log(error);
          this.$notify(setNotifyData('', 'Error has occurred', 'error'));
        });
      },
      clearFields(event) {
        event.preventDefault();
        cleanFilters(this.printData);
      }
    },
    computed: {
      modalTitle() {
        return `${this.$i18n.t('modal_dialogs.print_document.print_document')}`;
      }
    },
    mounted() {
      this.$root.$on('openPrintModal', (settings) => {
        if (this.$refs['printDocumentModal']) {
          this.settings = settings;
          this.openModal();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openPrintModal');
    }
  }
</script>

<style scoped>

  .margin {
    margin-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/PrintDocumentModal.vue